import React, { useState, useEffect } from "react";
import { useImpactReadOnly, openImpactBoxIfReadOnly } from "app/routes/psp/management/useImpactReadOnly";
import { useSelector } from "react-redux";
import IntlMessages, { IntlGetText } from "util/IntlMessages";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import Form from "./Form";
import Table from "./Table";
import { callApiAsync, postCreateUpdateLedaga, postDeleteLedaga } from "api/apiList";
import { BoolList, LesionSideList, LocationLesionsList, AmountMedicationList } from "constants/Enums";
import { NotificationManager } from "react-notifications";
import DeleteLedaga from "./Delete";

const LedagaDialog = ({ open, handleRequestClose, loadLedaga, ledagaInfo }) => {
  const readOnlyImpactView = useImpactReadOnly();
  const { selectedPrescription } = useSelector(({ management }) => management);
  const [openCRU, setOpenCRU] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [currentRowObj, setCurrentRowObj] = useState({});
  const msgSuccess = IntlGetText("core.SuccessSave");
  useEffect(() => {
    if (open) loadLedaga();
  }, [open]);

  const handleOpenCRU = () => setOpenCRU(true);
  const handleRequestCloseCRU = () => setOpenCRU(false);

  const handleCreateUpdate = async (data) => {
    await callApiAsync(
      () => postCreateUpdateLedaga(data),
      () => {
        handleRequestCloseCRU();
        NotificationManager.success(msgSuccess);
        loadLedaga();
      }
    );
  };

  const handleDelete = async () => {
    await callApiAsync(
      () => postDeleteLedaga(currentRowObj.id),
      () => {
        setOpenDeleteDialog(false);
        NotificationManager.success(msgSuccess);
        loadLedaga();
      }
    );
  };

  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={open}
        disableBackdropClick={true}
        onClose={handleRequestClose}
      >
        <DialogTitle>
          <IntlMessages id="ledaga.cardTitle" />
        </DialogTitle>
        <DialogContent>
          <Table
            data={!ledagaInfo || !ledagaInfo ? [] : ledagaInfo}
            handleOpenCRU={handleOpenCRU}
            handleOpenDel={() => setOpenDeleteDialog(true)}
            setCurrentRowObj={setCurrentRowObj}
            ledagaInfo={ledagaInfo}
            showAddButton={true}
            readOnly={readOnlyImpactView}
            lesionSideList={LesionSideList()}
            locationLesionsList={LocationLesionsList()}
            amountMedicationList={AmountMedicationList()}
          />
          <Form
            rowObj={currentRowObj}
            personId={selectedPrescription.patient.id}
            openCRU={openCRU}
            handleRequestClose={handleRequestCloseCRU}
            handleCreateUpdate={handleCreateUpdate}
            ledagaInfo={ledagaInfo}
            readOnly={readOnlyImpactView}
            boolList={BoolList()}
            lesionSideList={LesionSideList()}
            locationLesionsList={LocationLesionsList()}
            amountMedicationList={AmountMedicationList()}
          />
          <DeleteLedaga
            open={openDeleteDialog}
            handleRequestClose={() => setOpenDeleteDialog(false)}
            handleDelete={handleDelete}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRequestClose} color="secondary">
            <IntlMessages id="core.close" />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default LedagaDialog;
